import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import format from 'date-fns/format';
import { FormattedMessage, useIntl } from 'react-intl';
import Pagination from '../../../components/Pagination/Pagination';
import CustomTable from '../../../components/Table/Table';
import Button from '../../../components/Button/CustomButton';
import FormDialog from '../../../components/Dialog/FormDialog';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import {
    statusType,
    statusApprove,
    APIErrors,
    locationOption,
} from '../../../common/Constants';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Typography from '../../../components/Typography/CustomTypography';
import SnackBar from '../../../components/Snackbar/Snackbar';
import Loader from '../../../components/Loader/Loader';
import dateUtils from '../../../utils/dateUtils';
import { DownloadIcon } from '../../../components/Icons/Icon';
import adminListOrganizerStyle from '../../../assets/jss/pages/adminListOrganizerStyle';
import DialogRegister from '../../../containers/admin/OrganizerManagement/DialogRegister';

const ActionRow = ({ onApprove, onReject, ...rest }) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
        <Button onClick={onApprove} style={{ fontSize: '14px' }} color="success" {...rest}>承認</Button>
        &nbsp;
        <Button onClick={onReject} style={{ fontSize: '14px' }} color="danger" {...rest}>拒否</Button>
    </Box>
);
const useStyles = makeStyles(adminListOrganizerStyle);
const ListOrganizer = (props) => {
    const {
        fetchOrganizer,
        clearOrganizer,
        organizerResults,
        organizers,
        approveSuccess,
        approveResponse,
        approveErrors,
        onApproveOrganizer,
        clearApproveOrganizer,
        rejectSuccess,
        rejectResponse,
        rejectErrors,
        onRejectOrganizer,
        clearRejectOrganizer,
        options,
        isLoading,
        organizerDetail,
        fetchDetailOrganizer,
        clearDetailOrganizer,
        eventInfo,
        sendInvoice,
        invoiceSuccess,
        invoiceErrors,
        clearInvoice,
        resendMail,
        resendMailSuccess,
        resetResendMailData,
        zones,
        fetchEventZones,
        organizerDownloadData, successGetDownloadData, getCsvOrganizer, getCsvOrganizerClear,
        fetchClearGetListLiveStream,
        fetchGetListLiveStream,
        dataListLiveStream,
    } = props;

    const routeParams = useParams();
    const classes = useStyles();
    const intl = useIntl();
    const [organizerResultState, setOrganizerResultState] = useState([]);
    const [organizerDataTable, setOrganizerDataTable] = useState([]);
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [detailId, setDetailId] = useState('');
    const [detailStatus, setDetailStatus] = useState(false);
    const [organizerTypeDetail, setOrganizerTypeDetail] = useState({});
    const [organizerBoothDetail, setOrganizerBoothDetail] = useState({});
    const [companyDetails, setCompanyDetails] = useState({});
    const [userDetails, setUserDetails] = useState({});
    const [seminarDetails, setSeminarDetails] = useState({});
    const [liveStreamTable, setLiveStreamTable] = useState([]);

    // approve state
    const [isOpenApproveConfirm, setIsOpenApproveConfirm] = useState(false);
    const [isOpenApproveSuccessAlert, setIsOpenApproveSuccessAlert] = useState(false);
    const [isOpenApproveErrorAlert, setIsOpenApproveErrorAlert] = useState(false);
    const [approveErrorMessage, setApproveErrorMessage] = useState('');

    // reject state
    const [isOpenRejectConfirm, setIsOpenRejectConfirm] = useState(false);
    const [isOpenRejectSuccessAlert, setIsOpenRejectSuccessAlert] = useState(false);
    const [isOpenRejectErrorAlert, setIsOpenRejectErrorAlert] = useState(false);
    const [rejectErrorMessage, setRejectErrorMessage] = useState('');
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});

    // sendInvoice
    const [isOpenSendinvoiceSuccess, setIsOpenSendinvoiceSuccess] = useState(false);
    const [isOpenSendInvoiceError, setIsOpenSendInvoiceError] = useState(false);
    const [messageErrorSendInvoice, setMessageErrorSendInvoice] = useState(false);
    const [disableBtnInvoice, setDisableBtnInvoice] = useState(false);
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});

    // resend mail
    const [isOpenResendMailConfirmDialog, setOpenResendMailConfirmDialog] = useState(false);
    const [isOpenResendMailSuccessSnackbar, setOpenResendMailSuccessSnackbar] = useState(false);
    const userIdSelectedRef = useRef('');

    // dialog register
    const [isOpenDialogRegister, setIsOpenDialogRegister] = useState(false);

    useEffect(() => {
        const { shortName } = routeParams;
        if (!_.isEmpty(routeParams.shortName)) {
            fetchOrganizer({
                event_name: shortName,
            });
            fetchEventZones(shortName);
        }

        return () => {
            clearOrganizer();
            clearDetailOrganizer();
            getCsvOrganizerClear();
        };
    }, [routeParams, clearDetailOrganizer, clearOrganizer, fetchEventZones, fetchOrganizer, getCsvOrganizerClear]);

    useEffect(() => {
        setOrganizerResultState(organizerResults);
    }, [organizerResults]);

    const updateDateToTokyoTime = (date) => format(new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })), 'yyyy/MM/dd HH:mm');

    const handleGetCSV = (shortName) => {
        getCsvOrganizer({ shortName });
    };

    useEffect(() => {
        if (organizerDownloadData && successGetDownloadData) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', organizerDownloadData]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `出展者一覧${`${routeParams.shortName}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [organizerDownloadData, successGetDownloadData, routeParams.shortName]);

    useEffect(() => {
        if (!_.isEmpty(organizerResultState)) {
            const tableData = organizerResultState.map((organizer) => [
                organizer.user && organizer.user.email,
                organizer.user && organizer.user.uuid,
                // organizer.user && organizerType[organizer.user.organizer_type],
                organizer.user && renderOrganizerType(organizer.user.organizer_type, organizer.user.organizer_live_stream),
                organizer.company && organizer.company.full_name, // company name
                organizer.user && `${organizer.user.first_name} ${organizer.user.last_name}`,
                organizer.user && statusType.ja[organizer.user.status],
                (organizer.company && organizer.company.send_receipt) && updateDateToTokyoTime(new Date(organizer.company.send_receipt_time * 1000)),
                (organizer.user && organizer.user.status === statusApprove.AWAITING_APPROVAL) && (
                    <ActionRow
                        onApprove={(e) => handleOpenApproveConfirm(e, organizer.user.id)}
                        onReject={(e) => handleOpenRejectConfirm(e, organizer.user.id)}
                        size="sm"
                    />
                ),
                ((organizer.user && organizer.user.status === statusApprove.APPROVED) && (
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Button onClick={(event) => onResendMail(event, organizer.user.id)} style={{ fontSize: '14px' }}>再送信</Button>
                    </Box>
                )),
            ]);
            setOrganizerDataTable(tableData);
        }
    }, [organizerResultState]);

    useEffect(() => {
        if (approveSuccess && !_.isEmpty(approveResponse)) {
            const temp = organizerResultState.map((item) => {
                if (item.user.id === approveResponse.id) {
                    return {
                        ...item,
                        user: {
                            ...item.user, status: statusApprove.APPROVED,
                        },
                    };
                }
                return item;
            });
            setIsOpenApproveSuccessAlert(true);
            setOpenDialogDetail(false);
            setIsOpenApproveConfirm(false);
            setOrganizerResultState(temp);
            clearApproveOrganizer();
        } else if (!_.isEmpty(approveErrors)) {
            if (approveErrors.code === APIErrors.badRequest) {
                setIsOpenApproveConfirm(false);
                setApproveErrorMessage(approveErrors.message && approveErrors.message.message);
                setIsOpenApproveErrorAlert(true);
                clearApproveOrganizer();
                fetchOrganizer({
                    event_name: routeParams.shortName,
                    page: organizers.page,
                });
                fetchEventZones(routeParams.shortName);
            }
        }
    }, [approveSuccess, approveResponse, approveErrors]);

    useEffect(() => {
        if (rejectSuccess && !_.isEmpty(rejectResponse)) {
            const temp = organizerResultState.map((item) => {
                if (item.user.id === rejectResponse.id) {
                    return {
                        ...item,
                        user: {
                            ...item.user, status: statusApprove.REJECTED,
                        },
                    };
                }
                return item;
            });
            setIsOpenRejectSuccessAlert(true);
            setOpenDialogDetail(false);
            setIsOpenRejectConfirm(false);
            setOrganizerResultState(temp);
            clearRejectOrganizer();
        } else if (!_.isEmpty(rejectErrors)) {
            if (rejectErrors.code === APIErrors.badRequest) {
                setIsOpenRejectConfirm(false);
                setRejectErrorMessage(rejectErrors.message && rejectErrors.message.message);
                setIsOpenRejectErrorAlert(true);
                clearRejectOrganizer();
                fetchOrganizer({
                    event_name: routeParams.shortName,
                });
                fetchEventZones(routeParams.shortName);
            }
        }
    }, [rejectSuccess, rejectResponse, rejectErrors]);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    useEffect(() => {
        const { company, user, seminars } = organizerDetail;
        if (user) {
            setDetailId(user.id);
            setDetailStatus(user.status);

            const infoUser = [
                {
                    name: '部署',
                    value: user.department,
                },
                {
                    name: '役職',
                    value: user.position,
                },
                {
                    name: 'メールアドレス',
                    value: user.email,
                },
                {
                    name: '氏名',
                    value: `${user.first_name} ${user.last_name}`,
                },
                {
                    name: '国・地域',
                    value: locationOption.ja[user.location],
                },
                {
                    name: '郵便番号',
                    value: user.zip_code,
                },
                {
                    name: '住所',
                    value: user.address,
                },
                {
                    name: '電話番号',
                    value: user.phone_number,
                },
                {
                    name: '状態',
                    value: statusType.ja[user.status],
                },
            ];
            const infoUserEN = [
                {
                    name: '部署',
                    value: user.department,
                },
                {
                    name: '役職',
                    value: user.position,
                },
                {
                    name: 'メールアドレス',
                    value: user.email,
                },
                {
                    name: '氏名',
                    value: `${user.first_name} ${user.last_name}`,
                },
                {
                    name: '国・地域',
                    value: locationOption.ja[user.location],
                },
                {
                    name: '郵便番号',
                    value: user.zip_code,
                },
                {
                    name: '住所（和文）',
                    value: user.address,
                },
                {
                    name: '住所（英字）',
                    value: user.address_en,
                },
                {
                    name: '電話番号',
                    value: user.phone_number,
                },
                {
                    name: '状態',
                    value: statusType.ja[user.status],
                },
            ];
            setOrganizerTypeDetail({
                name: '出展種別',
                // value: organizerType[user.organizer_type],
                value: renderOrganizerType(user.organizer_type, user.organizer_live_stream),
            });
            setOrganizerBoothDetail({
                name: 'ブース種別',
                value: renderBoothType(user.organizer_booth),
            });
            setUserDetails(!_.isEmpty(eventInfo.languages) ? infoUserEN : infoUser);
        }
        if (company) {
            const infoCompany = [
                {
                    name: '出展企業名\n（和文・英文）',
                    value: company.full_name,
                },
                {
                    name: '社名 \n（カナ・英字）',
                    value: company.short_name,
                },
                {
                    name: '業種',
                    value: company.company_type,
                },
                {
                    name: '職種',
                    value: user.occupation_name,
                },
                {
                    name: '従業員数',
                    value: listOptionEmployeeNumberFromApi[user.employee_number],
                },
            ];
            const infoCompanyEN = [
                {
                    name: '出展企業名\n（和文）',
                    value: company.full_name,
                },
                {
                    name: '出展企業名\n（英文）',
                    value: company.full_name_en,
                },
                {
                    name: '社名（カナ）',
                    value: company.short_name,
                },
                // {
                //     name: '社名（英字）',
                //     value: company.short_name_en,
                // },
                {
                    name: '業種',
                    value: company.company_type,
                },
                {
                    name: '職種',
                    value: user.occupation_name,
                },
                {
                    name: '従業員数',
                    value: listOptionEmployeeNumberFromApi[user.employee_number],
                },
            ];
            setCompanyDetails(!_.isEmpty(eventInfo.languages) ? infoCompanyEN : infoCompany);
            setDisableBtnInvoice(company.send_receipt || organizerDetail?.user?.status === statusApprove.REJECTED);
        }
        if (seminars) {
            const arrData = [];
            seminars.forEach((element) => {
                arrData.push([
                    `${element.room} ( ${element.organization_price}円 )`,
                    dateUtils.formatJa(new Date(element.date)),
                    `${element.stime} ~ ${element.etime}`,
                ]);
            });

            setSeminarDetails(arrData);
        }
    }, [organizerDetail]);

    useEffect(() => {
        if (!_.isEmpty(dataListLiveStream)) {
            const tableData = dataListLiveStream.map((item, index) => [
                item.title,
                `${item.stime}~${item.etime}`,
                (item.dates).map((date) => <p>{format(new Date(date), 'yyyy/MM/dd')}</p>),
                item.cost === 0 ? '無料' : `${intl.formatNumber(item.cost)}円`,
            ]);
            setLiveStreamTable(tableData);
        }
    }, [dataListLiveStream]);

    useEffect(() => {
        if (invoiceSuccess) {
            const { shortName } = routeParams;
            setIsOpenSendinvoiceSuccess(true);
            setDisableBtnInvoice(true);
            fetchOrganizer({
                event_name: shortName,
            });
        }
        return () => {
            clearInvoice();
        };
    }, [invoiceSuccess]);

    useEffect(() => {
        if (invoiceErrors.code === 'BAD_REQUEST') {
            setMessageErrorSendInvoice(invoiceErrors.message.message);
            setIsOpenSendInvoiceError(true);
        }
    }, [invoiceErrors]);

    useEffect(() => {
        if (resendMailSuccess) {
            resetResendMailData(); // reset data resend mail in redux store
            userIdSelectedRef.current = ''; // reset selected user id
            setOpenResendMailSuccessSnackbar(true);
        }
    }, [resendMailSuccess]);

    const renderOrganizerType = (typeSeminarAndBooth, typeLiveStream) => {
        let result = '';
        if (typeSeminarAndBooth === 0 && !typeLiveStream) {
            return '';
        }
        if (typeSeminarAndBooth === 3 && typeLiveStream) {
            return '展示会・セミナー・ライブ配信';
        }
        if (typeSeminarAndBooth === 3 && !typeLiveStream) {
            return '展示会・セミナー';
        }
        if (typeSeminarAndBooth === 1) {
            result = '展示会';
        }
        if (typeSeminarAndBooth === 2) {
            result = 'セミナー';
        }
        if (typeLiveStream && !result) {
            return 'ライブ配信のみ';
        }
        if (typeLiveStream && result) {
            result = result.concat('・ライブ配信');
        } else {
            result = result.concat('のみ');
        }
        return result;
    };

    const renderBoothType = (type) => {
        switch (type) {
            case 1:
                return _.get(eventInfo, 'setting_booth.small_zone.name');
            case 2:
                return _.get(eventInfo, 'setting_booth.standard_zone.name');
            case 3:
                return _.get(eventInfo, 'setting_booth.big_zone.name');
            case 4:
                return _.get(eventInfo, 'setting_booth.grand_zone.name');
            default:
                return null;
        }
    };

    const handleOpenApproveConfirm = (e, id) => {
        e.stopPropagation();
        setDetailId(id);
        setIsOpenApproveConfirm(true);
    };

    const handleOpenRejectConfirm = (e, id) => {
        e.stopPropagation();
        setDetailId(id);
        setIsOpenRejectConfirm(true);
    };

    const handleApproved = () => {
        onApproveOrganizer(detailId);
    };

    const handleReject = () => {
        onRejectOrganizer(detailId);
    };

    const onResendMail = (event, userId) => {
        event.stopPropagation();
        userIdSelectedRef.current = userId;
        setOpenResendMailConfirmDialog(true);
    };

    const handleSubmitResendMail = () => {
        if (resendMail) {
            resendMail({
                user_id: userIdSelectedRef.current,
            });
            setOpenResendMailConfirmDialog(false);
        }
    };

    const handleSearchWithPage = (currentPage) => {
        if (fetchOrganizer) {
            const { shortName } = routeParams;
            fetchOrganizer({
                event_name: shortName,
                page: currentPage,
            });
        }
    };

    const handleShowDialogTitle = (index) => {
        if (organizerResults[index]) {
            setOpenDialogDetail(true);
            const { shortName } = routeParams;
            fetchDetailOrganizer({
                event_name: shortName,
                company_id: organizerResults[index].company.id,
            });
        }
    };

    const handleCloseDialogDetail = () => {
        setLiveStreamTable({});
        setOpenDialogDetail(false);
        setDetailId('');
        setDetailStatus(false);
        setOrganizerTypeDetail({});
        setOrganizerBoothDetail({});
        setCompanyDetails({});
        setUserDetails({});
        setSeminarDetails({});
    };

    const handleSendInvoice = () => {
        if (organizerDetail.company && organizerDetail.company.id) {
            sendInvoice(organizerDetail.company.id);
        }
    };
    return (
        <>
            <div className={classes.organizerButton}>
                {organizerDataTable?.length > 0 && (
                    <Button
                        color="info"
                        gradient
                        size="md"
                        round
                        onClick={() => handleGetCSV(routeParams.shortName)}
                        download
                    >
                        <DownloadIcon />
                        &#160;
                        CSVダウンロード
                    </Button>
                )}
                <Button
                    color="info"
                    gradient
                    size="md"
                    round
                    onClick={() => setIsOpenDialogRegister(true)}
                    download
                    className={classes.organizerButtonRegister}
                >
                    新規申込み
                </Button>
            </div>
            <DialogRegister
                isOpen={isOpenDialogRegister}
                handleClose={() => setIsOpenDialogRegister(false)}
                eventInfo={eventInfo}
                getListOrganizer={(shortName) => fetchOrganizer({ event_name: shortName })}
            />

            <CustomTable
                onClick={(index) => handleShowDialogTitle(index)}
                tableHead={['メールアドレス', 'アカウントID', '出展種別', '企業名', '担当者名', '承認状態', '請求書発送日', 'アクション', 'ログイン通知再送']}
                tableHeadWidth={['15%', '10%', '10%', '15%', '10%', '10%', '10%', '10%', '10%']}
                tableData={organizerDataTable}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={organizers.page}
                            total={organizers.total_page}
                            onChange={(page) => handleSearchWithPage(page)}
                        />
                    </Box>
                )}
            />
            <FormDialog
                isOpen={openDialogDetail}
                handleClose={handleCloseDialogDetail}
                actions={detailStatus === statusApprove.AWAITING_APPROVAL && (
                    <ActionRow
                        onApprove={(e) => handleOpenApproveConfirm(e, detailId)}
                        onReject={(e) => handleOpenRejectConfirm(e, detailId)}
                        size="md"
                    />
                )}
            >
                <div>
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem xs={12} md={5}>
                            <Typography bold variant="h6">
                                ※申込み済み展示会・セミナー情報
                            </Typography>
                        </GridItem>
                    </GridContainer>
                    {

                        !_.isEmpty(organizerTypeDetail.value) && (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        {organizerTypeDetail.name}
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {organizerTypeDetail.value}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        )
                    }
                    {
                        (!_.isEmpty(zones) && !_.isEmpty(organizerDetail)) && (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        ゾーン
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {zones.filter((item) => item.id === organizerDetail.user.zone)[0]?.name}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        )
                    }
                    {

                        !_.isEmpty(organizerBoothDetail.value) && (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        {organizerBoothDetail.name}
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {organizerBoothDetail.value}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        )
                    }
                    {!_.isEmpty(seminarDetails)
                        ? (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        セミナー情報
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    {seminarDetails.length > 0 && (
                                        <CustomTable
                                            tableHead={['会議室', '月日', '時間']}
                                            tableHeadWidth={['30%', '40%', '30%']}
                                            tableData={seminarDetails}
                                            className={classes.maxHeight}
                                            pointerLess
                                        />

                                    )}
                                </GridItem>
                            </GridContainer>
                        ) : (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        セミナー情報
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    申し込んでいません。
                                </GridItem>
                            </GridContainer>
                        )}
                    {!_.isEmpty(liveStreamTable)
                        ? (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        ライブ配信
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    {liveStreamTable.length > 0 && (
                                        <CustomTable
                                            tableHead={['タイトル', '時間帯', '日程', '有料・無料']}
                                            tableHeadWidth={['25%', '25%', '25%', '25%']}
                                            tableData={liveStreamTable}
                                            className={classes.maxHeight}
                                            pointerLess
                                        />
                                    )}
                                </GridItem>
                            </GridContainer>
                        ) : (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        ライブ配信
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    申し込んでいません。
                                </GridItem>
                            </GridContainer>
                        )}
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem md={1} />
                        <GridItem md={2}>
                            <Typography bold>
                                広告申込
                            </Typography>
                        </GridItem>
                        <GridItem md={9}>
                            <Typography>
                                {organizerDetail.company && organizerDetail.company.register_ads_max > 0 ? 'する' : 'しない'}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                    {organizerDetail.company && organizerDetail.company.register_ads_max > 0
                        && (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        広告募集件数
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {organizerDetail.company.register_ads_max}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        )}
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem xs={12} md={4}>
                            <Typography bold variant="h6">
                                ※企業基本情報
                            </Typography>
                        </GridItem>
                    </GridContainer>
                    {
                        !_.isEmpty(companyDetails) && companyDetails.map((prop, index) => (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }} key={Number(index)}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        {prop.name}
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {prop.value}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        ))
                    }
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem xs={12} md={4}>
                            <Typography bold variant="h6">
                                ※連絡担当者
                            </Typography>
                        </GridItem>
                    </GridContainer>
                    {
                        !_.isEmpty(userDetails) && userDetails.map((prop, index) => (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }} key={Number(index)}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        {prop.name}
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {prop.value}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        ))
                    }
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem md={1} />
                        <GridItem md={2}>
                            <Typography bold>
                                支払い方法
                            </Typography>
                        </GridItem>
                        {organizerDetail?.company?.payment_method ? (
                            <GridItem md={9}>
                                <Typography>
                                    {organizerDetail?.company?.payment_method === 1 ? 'クレジット' : '銀行口座'}
                                </Typography>
                            </GridItem>
                        ) : ''}
                    </GridContainer>
                    {!eventInfo.outer_server_activation && (
                        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                            <Button
                                color="success"
                                size="md"
                                onClick={handleSendInvoice}
                                disabled={disableBtnInvoice}
                            >
                                {disableBtnInvoice ? '発注書送付済み' : '請求書を送付'}
                            </Button>
                        </Box>
                    )}
                </div>
            </FormDialog>
            <SnackBar
                severity="success"
                message={<FormattedMessage id="apiSuccess.default" />}
                open={isOpenApproveSuccessAlert}
                onClose={() => setIsOpenApproveSuccessAlert(false)}
            />
            <SnackBar
                severity="error"
                message={approveErrorMessage}
                open={isOpenApproveErrorAlert}
                onClose={() => setIsOpenApproveErrorAlert(false)}
            />
            <SnackBar
                severity="success"
                message={<FormattedMessage id="apiSuccess.default" />}
                open={isOpenRejectSuccessAlert}
                onClose={() => setIsOpenRejectSuccessAlert(false)}
            />
            <SnackBar
                severity="error"
                message={rejectErrorMessage}
                open={isOpenRejectErrorAlert}
                onClose={() => setIsOpenRejectErrorAlert(false)}
            />
            <AlertDialog
                handleOpen={isOpenApproveConfirm}
                handleClose={() => setIsOpenApproveConfirm(false)}
                handleSubmit={handleApproved}
                contents="承認しますか？"
            />
            <AlertDialog
                contents="拒否しますか？"
                handleOpen={isOpenRejectConfirm}
                handleClose={() => setIsOpenRejectConfirm(false)}
                handleSubmit={handleReject}
            />
            <Loader isLoading={isLoading} />
            <SnackBar
                severity="success"
                message="発注書をこの出展企業のメールアドレスに送付しました。"
                open={isOpenSendinvoiceSuccess}
                onClose={() => setIsOpenSendinvoiceSuccess(false)}
            />
            <SnackBar
                severity="error"
                message={messageErrorSendInvoice}
                open={isOpenSendInvoiceError}
                onClose={() => setIsOpenSendInvoiceError(false)}
            />
            <AlertDialog
                contents="メールを再送信しますが、よろしいでしょうか？。"
                handleOpen={isOpenResendMailConfirmDialog}
                handleClose={() => setOpenResendMailConfirmDialog(false)}
                handleSubmit={handleSubmitResendMail}
            />
            <SnackBar
                severity="success"
                message="メールを成功に再送信しました。"
                open={isOpenResendMailSuccessSnackbar}
                onClose={() => setOpenResendMailSuccessSnackbar(false)}
            />
        </>
    );
};

ListOrganizer.defaultProps = {
    organizerResults: [],
    organizers: {},
    approveResponse: {},
    approveSuccess: false,
    approveErrors: {},
    rejectResponse: {},
    rejectSuccess: false,
    rejectErrors: {},
    options: {},
    organizerDetail: {},
    eventInfo: {},
    invoiceSuccess: false,
    invoiceErrors: {},
    resendMail: () => {},
    resetResendMailData: () => {},
    resendMailSuccess: false,
    zones: [],
    dataListLiveStream: [],
};

ListOrganizer.propTypes = {
    fetchOrganizer: PropTypes.func.isRequired,
    clearOrganizer: PropTypes.func.isRequired,
    fetchDetailOrganizer: PropTypes.func.isRequired,
    clearDetailOrganizer: PropTypes.func.isRequired,
    organizerResults: PropTypes.oneOfType([() => null, PropTypes.array]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    organizers: PropTypes.oneOfType([() => null, PropTypes.object]),
    organizerDetail: PropTypes.oneOfType([() => null, PropTypes.object]),
    approveResponse: PropTypes.oneOfType([() => null, PropTypes.object]),
    approveErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    approveSuccess: PropTypes.bool,
    onApproveOrganizer: PropTypes.func.isRequired,
    clearApproveOrganizer: PropTypes.func.isRequired,
    rejectResponse: PropTypes.oneOfType([() => null, PropTypes.object]),
    rejectErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    rejectSuccess: PropTypes.bool,
    onRejectOrganizer: PropTypes.func.isRequired,
    clearRejectOrganizer: PropTypes.func.isRequired,
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    sendInvoice: PropTypes.func.isRequired,
    clearInvoice: PropTypes.func.isRequired,
    invoiceSuccess: PropTypes.bool,
    invoiceErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    resendMail: PropTypes.func,
    resetResendMailData: PropTypes.func,
    resendMailSuccess: PropTypes.bool,
    zones: PropTypes.oneOfType(() => null, PropTypes.array),
    fetchEventZones: PropTypes.func.isRequired,
    organizerDownloadData: PropTypes.func.isRequired,
    successGetDownloadData: PropTypes.func.isRequired,
    getCsvOrganizer: PropTypes.func.isRequired,
    getCsvOrganizerClear: PropTypes.func.isRequired,
    dataListLiveStream: PropTypes.oneOfType(() => null, PropTypes.array),
};

ActionRow.propTypes = {
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

export default ListOrganizer;
